
module.exports = {
    LOGIN_PATH: './',
    title: 'vue + webpack4 + element-ui脚手架项目',
    description: 'vue + webpack4 + element-ui脚手架项目',

    themeColor: '#f67a17'
}
